


















































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { setMetaData, timeFormat, downloadFile, setValue } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import {
  GetOptionsForAttendanceReportReq,
  ListGroupAttendanceReq,
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { BatchAssignTicketReq } from "@/pbjs/external/ticket/ticket_pb";
import {
  ticketClient,
  authorClient,
  collectionServiceClient,
  client,
} from "@/api/index";
import {
  GetTicketListParamReq,
  WorkOrderStatisticReq,
  WAGetQRCodeReq,
  WALoginStatusReq,
  ImportWAPhoneReq,
  WAListReq,
  AssignWAPhoneReq,
  MarkWAPhoneReq,
} from "@/pbjs/xcommon/ticket_pb";
// import { ,  } from "@/pbjs/external/ticket/ticket_pb";
@Component({
  name: "PerformanceManagement",
  filters: {
    filter(value: any, key: any) {
      const filterArr = value.filter((item: any) => {
        return item[0] == key;
      });
      return filterArr.length > 0 ? filterArr[0][1].total : 0;
    },
    filterpercent(value: any, key: any) {
      const filterArr1 = value.filter((item: any) => {
        return item[0] == key;
      });
      // var num=  (Math.round(filterArr1[0][1].percentage*100)/100)+'%'
      return filterArr1.length > 0
        ? Math.round(filterArr1[0][1].percentage * 100) / 100 + "%"
        : "0%";
    },
    percenttage(num: any) {
      return Math.round(num * 100) / 100 + "%";
    },
  },
})
export default class PerformanceManagement extends Vue {
  @Provide() private Mobile: any = "";
  @Provide() private searchForm: any = {};
  @Provide() private isSearchFormActionDone: boolean = false;
  @Provide() private userSearchPhone: any = '';
  @Provide() private userSearchAssignUserId: any = '';
  @Provide() private hasSearchLoading: boolean = false;
  @Provide() private userPagerCount: number = 0;
  @Provide() private selectedAssignUser: any;
  @Provide() private ticketSelection: any = [];
  @Provide() private selectedTicketIds: number[] = [];
  @Provide() private isImport: boolean = true;
  @Provide() private ifMask: boolean = true;
  @Provide() private flag: boolean = true;
  @Provide() private QRcodeurl: any = "";
  @Provide() private showDialogType: number = 0;
  @Provide() private isinputVisibleMore: boolean = false;
  @Provide() private inputVisibleMore: any = "";
  @Provide() private pagnition: any = pagnition;
  @Provide() private ticketTypeOptions: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private updatedTime: any = "";
  @Provide() private resultData: any = [];
  @Provide() private roleOptions: any = [];
  @Provide() private totalData: any = [];
  @Provide() private isGetTicketListExcelActionDone: any = false;
  @Provide() private connectedmap: any = [];
  @Provide() private unconnectedmap: any = [];
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private dynamicTags: any = [];
  @Provide() private inputVisible: any = false;
  @Provide() private inputValue: any = "";
  @Provide() private assignTid: any = "";
  @Provide() private userData: any = [];
  @Provide() private searchUserIds: any = [];
  @Provide() private isSearchUserActionDone: boolean = false;
  @Provide() private userid: any = localStorage.getItem("userid");

  @Provide() private userForm: any = {
    email: "",
    name: "",
    role: "",
  };
  @Provide() private userPageIndex: number = 1;

  private created() {
    this.getList();
    this.getRoleListAPI();
  }
  // 导入电话号码
  private getSubmit() {
    this.isGetTicketListExcelActionDone = true;
    if (this.dwGetTicketListReqParamsNeed()) {
      let request = new ImportWAPhoneReq();
      request.setCommonin(setCommon());
      // dynamicTags.join(",")
      request.setPhone(this.inputVisibleMore);
      console.log(request);

      ticketClient.importWAPhone(request, {}, (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout.code === 0) {
            this.inputVisibleMore = "";
            this.$message("success");
            this.getList();
          }
        }
        this.isGetTicketListExcelActionDone = false;
      });
    }
  }
  private closeDialog() {
    this.showDialogType = 0;
    this.getWALoginStatusReq()
  }
  private showBatchInput() {
    this.isinputVisibleMore = true;
  }
  private getSearch() {
    this.hasSearchLoading = true
    this.pageIndex = 0
    this.getList()
  }
  //获取列表
  private getList() {
    let request = new WAListReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    request.setPhone(this.userSearchPhone);
    request.setAssignuid(this.userSearchAssignUserId);
    ticketClient.getWAList(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        console.log(data);
        if (data.commonout.code == 0) {
          this.pagerCount = data.pageout.total;
          data.listList.forEach((item: any) => {
            const strArr = item.phone.split('')
            strArr.splice(-8, 4, '*', '*', '*', '*')
            item.phoneShow = strArr.join('')
          });
          this.resultData = data.listList;
        } else {
          this.$message(data.commonout.errmsg);
        }
      }
      this.hasSearchLoading = false
    });
  }
  private showOrHideSearchRegion() {
    this.isShowSearchRegion = !this.isShowSearchRegion;
  }
  //查询项数字校验
  private inputFuction(e: any) {
    this.inputValue = e.replace(/[^0-9]/g, "");
  }
  private handleClose(tag: any) {
    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
  }

  private showInput(index: number) {
    this.inputVisible = true;
    console.log(this.inputVisible, "222222222222");
    this.$nextTick(() => {
      // this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  private handleRoleChange(val: any) {
    this.selectedAssignUser = val;
    // console.log("selectedUser", val);
  }
  private handleInputConfirm() {
    let inputValue = this.inputValue;
    if (inputValue) {
      this.dynamicTags.push(inputValue);
    }
    this.inputVisible = false;
    this.inputValue = "";
  }
  //获取二维码
  private getGetQRcode(row: any) {
    // if (this.dwGetTicketListReqParamsNeed()) {

    this.showDialogType = 1;
    let request = new WAGetQRCodeReq();
    request.setCommonin(setCommon());
    request.setMobile(row.phone);
    console.log(request);
    ticketClient.wAGetQRCode(request, {}, (err: any, response: any) => {
      console.log(response);

      if (response) {
        let data: any = response.toObject();
        console.log(data);

        //获取二维码成功
        if (data.commonout.code == 0) {
          //展示二维码
          this.flag = false;
          // this.ifMask = false;
          this.QRcodeurl = data.url;
          //获取状态
          // this.getWALoginStatusReq();
          // this.setTimeout(true);
        } else {
          this.$message(data.commonout.errmsg);
        }
      }
      if (err) {
        this.$message(response.commonout.errmsg);
      }
    });
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getList();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getList();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getList();
  }
  private doMassOutsource() {
    this.showDialogType = 0;
    this.getList();
    this.getWALoginStatusReq()
  }
  private massAssign(item: any) {
    // this.showDialogTypeMore=true
    this.showDialogType = 4;
    this.searchUser();
    this.assignTid = item.id;
  }
  private calloutWA(item: any) {
    let request: any = new MarkWAPhoneReq();
    request.setCommonin(setCommon());
    request.setId(item.id);
    request.setMarktype(1);
    request.setOpuid(this.userid);
    ticketClient.markWAPhone(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        // console.log(JSON.stringify(data), "user");
        let _fuc = this.batchAssignTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private searchUser() {
    let searchRequest: any = new SearchUserReq();
    searchRequest.setCommonin(setCommon());
    searchRequest.setName(this.userForm.name);
    searchRequest.setEmail(this.userForm.email);
    searchRequest.setUsergroup(this.userForm.role);
    searchRequest.setPagein(setPage(this.userPageIndex, this.pageSize));
    // console.log(searchRequest, "searchUser");
    client.searchUser(searchRequest, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        // console.log(JSON.stringify(data), "user");
        let _fuc = this.searchUserFuc;
        handleResponse(data, _fuc);
        if (data.commonout.code == 102) {
          this.pagerCount = 0;
          this.userData = [];
        }
      }
      if (err) {
        errorMsg(err);
      }
      this.isSearchUserActionDone = false;
    });
  }
  private getRoleListAPIFuc(data: any) {
    if (data.usergroupinfosList) {
      this.roleOptions = data.usergroupinfosList;
    }
  }
  private getRoleListAPI() {
    let request: any = setCommon();
    authorClient.listUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        console.log(data, "role11");
        let _fuc = this.getRoleListAPIFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private searchUserAction() {
    this.isSearchUserActionDone = true;
    this.userPageIndex = 1;
    this.searchUser();
  }
  private searchUserFuc(data: any) {
    if (data.userinfosList) {
      this.userPagerCount = data.pageout.total;
      this.userData = data.userinfosList;
      this.searchUserIds = [];
      this.userData.forEach((item: any) => {
        this.searchUserIds.push(item.id);
      });
      this.batchGetLoginInfo();
    }
  }
  private batchGetLoginInfoFuc(data: any) {
    let map: any = new Map(data.logininfomapMap);
    this.userData.forEach((item: any) => {
      if (map.has(item.id) && map.get(item.id).status) {
        this.$set(item, "online", this.$t("v0707.Yes"));
      } else {
        this.$set(item, "online", this.$t("v0707.No"));
      }
      // item.online = map.has(item.id) && map.get(item.id).status;
    });
    // console.log(this.userData);
  }
  private batchGetLoginInfo() {
    let request: any = new BatchGetLoginInfoReq();
    request.setCommonin(setCommon());
    request.setUseridList(this.searchUserIds);
    // console.log(request, "batchrequest");
    client.batchGetLoginInfo(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        // console.log(data, "batchGetLoginInfo");
        let _fuc = this.batchGetLoginInfoFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private handleAssignCurrentChange(val: any) {
    this.userPageIndex = Number(val);
    //展示表格数据
    this.searchUser();
  }

  //点击上一页
  private handleAssignPrevChange(val: any) {
    if (this.userPageIndex > 0) {
      //展示表格数据
      this.searchUser();
    }
  }

  //点击下一页
  private handleAssignNextChange(val: any) {
    //展示表格数据
    this.searchUser();
  }

  private handleAssignSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.searchUser();
  }
  private confirmMassAssign() {
    this.findSelectedIds();
    this.batchAssignTicket();
  }
  private findSelectedIds() {
    this.selectedTicketIds = [];
    this.ticketSelection.forEach((item: any) => {
      this.selectedTicketIds.push(item.ticket.id);
    });
  }
  // private handleSelectionChange(val: any) {
  //   this.ticketSelection = val;
  // }
  // private massRecyle() {
  //   if (this.ticketSelection.length > 0) {
  //     this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
  //       confirmButtonText: this.$tc("authority.ok"),
  //       cancelButtonText: this.$tc("authority.cancel"),
  //       type: "warning",
  //     })
  //       .then(() => {
  //         this.findSelectedIds();
  //         // this.batchRecycleTicket();
  //       })
  //       .catch(() => {});
  //   } else {
  //     this.$message.error("Pls choose the order classify");
  //   }
  // }
  private batchAssignTicketFuc(data: any) {
    this.showDialogType = 0;
    this.getList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private batchAssignTicket() {
    console.log(this.selectedTicketIds, "%%%%%%%%%%");
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    }); // 转换类型为string array
    let request: any = new AssignWAPhoneReq();
    request.setCommonin(setCommon());
    request.setId(Number(this.assignTid));
    request.setAssignuid(this.selectedAssignUser.id);
    request.setOpuid(Number(this.userid));
    console.log(request, "AssignWAPhoneReq");
    ticketClient.assignWAPhone(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        // console.log(JSON.stringify(data), "assign");
        let _fuc = this.batchAssignTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  //  lee 取消分配操作，傳入ExtNumber參數
  private assignItem(item: any) {
    console.log(this.selectedTicketIds, "%%%%%%%%%%");
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    }); // 转换类型为string array
    let request: any = new AssignWAPhoneReq();
    request.setCommonin(setCommon());
    request.setId(Number(item.id));
    request.setAssignuid(item.assignuid);
    request.setOpuid(Number(this.userid));
    console.log(request, "unAssignWAPhoneReq");
    ticketClient.unAssignWAPhone(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        // console.log(JSON.stringify(data), "assign");
        let _fuc = this.batchAssignTicketFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  //获取登陆状态
  private getWALoginStatusReq() {
    let request = new WALoginStatusReq();
    request.setCommonin(setCommon());
    request.setMobile(this.Mobile);
    ticketClient.wALoginStatus(request, {}, (err: any, response: any)=>{});
  }

  //单独请求
  // private wAGetQRCode() {
  //   if (this.dwGetTicketListReqParamsNeed()) {
  //     let request = new WAGetQRCodeReq();
  //     request.setCommonin(setCommon());
  //     request.setMobile(this.Mobile);
  //     console.log(request);
  //     ticketClient.wAGetQRCode(request, {}, (err: any, response: any) => {
  //       let data: any = response.toObject();
  //       console.log(data);
  //       if (response) {
  //         //获取二维码成功
  //         if (data.commonout.code == 0) {
  //           //更换二维码
  //           // this.flag = false;
  //           this.QRcodeurl = data.url;
  //           // this.setTimeout(true);
  //         } else {
  //           // this.setTimeout(false);
  //         }
  //       }
  //     });
  //   } else {
  //     // this.setTimeout(false);
  //   }
  // }
  // private setTimeout(flag: any) {
  //   let timer;
  //   if (flag) {
  //     timer = null;
  //     //三秒钟更换二维码
  //     timer = setTimeout(() => {
  //       this.wAGetQRCode();
  //     }, 10000);
  //   } else {
  //     clearInterval(timer);
  //   }
  // }
  //获取登陆状态
  // private getWALoginStatusReq() {
  //   // if (this.dwGetTicketListReqParamsNeed()) {
  //   let request = new WALoginStatusReq();
  //   request.setCommonin(setCommon());
  //   request.setMobile(this.Mobile);
  //   ticketClient.wALoginStatus(request, {}, (err: any, response: any) => {
  //     let data: any = response.toObject();
  //     console.log(data);

  //     let times;
  //     if (response) {
  //       //获取状态成功
  //       if (data.commonout.code == 0 && data.status == 1) {
  //         //   展示表格
  //         this.resultData.push({
  //           Mobile: this.Mobile,
  //           state: "success",
  //         });
  //         //清除登录状态轮询
  //         clearInterval(times);
  //         //清除二维码轮询
  //         //   this.setTimeout(false);
  //         //弹出遮罩
  //         //   this.flag = true;
  //         //   this.ifMask = true;
  //       } else {
  //         times = null;
  //         switch (data.commonout.code) {
  //           case 100100:
  //             this.$router.push("./login");
  //             break;
  //           case 100101:
  //             this.$router.push("./login");
  //             break;
  //           default:
  //             times = setTimeout(() => {
  //               this.getWALoginStatusReq();
  //             }, 3000);
  //         }
  //       }
  //     } else if (err) {
  //       times = null;
  //       times = setTimeout(() => {
  //         this.getWALoginStatusReq();
  //       }, 3000);
  //     }
  //   });
  //   // }
  // }
  //  必传参数处理
  private dwGetTicketListReqParamsNeed() {
    // dynamicTags
    if (this.inputVisibleMore.length > 0) {
      return true;
    } else {
      this.isGetTicketListExcelActionDone = false;
      this.$message.error(this.$tc("pls make sure you’ve provided Mobile"));
      return false;
    }
  }
}
